import React, { useEffect } from 'react';
import styled from 'styled-components';
import Seo from '../components/common/Seo';
import { colors, breakpoints } from '../styles/variables';

const Page = styled.div`
  background: ${colors.lightGray};
  min-height: calc(100vh - 200px);
`;

const Hero = styled.section`
  background: linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 140%);
  color: ${colors.white};
  padding: 120px 24px 56px;
`;

const HeroInner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 38px;
  font-weight: 700;
  margin: 0 0 14px;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 28px;
  }
`;

const Lead = styled.p`
  font-size: 16px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.85);
  max-width: 760px;
  margin: 0;
`;

const Section = styled.section`
  max-width: 1100px;
  margin: 0 auto;
  padding: 80px 24px;
`;

const ComingSoon = styled.div`
  background: ${colors.white};
  border-radius: 16px;
  padding: 64px 32px;
  text-align: center;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);

  h2 {
    font-size: 24px;
    font-weight: 700;
    color: ${colors.primary};
    margin: 0 0 12px;
  }

  p {
    font-size: 15px;
    line-height: 1.8;
    color: ${colors.textGray};
    max-width: 540px;
    margin: 0 auto;
  }

  small {
    display: block;
    margin-top: 16px;
    font-size: 12px;
    color: ${colors.tertiary};
    letter-spacing: 0.05em;
  }
`;

const Preview = styled.div`
  margin-top: 40px;

  h3 {
    font-size: 18px;
    font-weight: 700;
    color: ${colors.primary};
    margin: 0 0 16px;
    text-align: center;
  }

  ul {
    list-style: none;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 12px;
  }

  li {
    background: ${colors.white};
    border: 1px solid ${colors.lightGray};
    border-radius: 10px;
    padding: 18px 20px;
    font-size: 14px;
    color: ${colors.textGray};
    line-height: 1.6;

    strong {
      display: block;
      color: ${colors.primary};
      font-size: 15px;
      margin-bottom: 4px;
    }
  }
`;

const BlogPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Page>
      <Seo
        title="블로그 (준비중)"
        description="ElectroWave Club 블로그는 곧 공개됩니다. 멘토들이 직접 쓰는 학습 가이드와 프로젝트 회고를 준비 중입니다."
        path="/blog"
        ogType="website"
        noindex
      />

      <Hero>
        <HeroInner>
          <Title>Blog</Title>
          <Lead>
            멘토들이 직접 쓰는 학습 가이드, 프로젝트 회고, 그리고 도구 사용기를 모아 놓을 공간입니다.
          </Lead>
        </HeroInner>
      </Hero>

      <Section>
        <ComingSoon>
          <h2>준비 중입니다</h2>
          <p>
            블로그 콘텐츠를 차근차근 정리하고 있습니다. 첫 글이 올라가면 메일과 SNS로 알려 드릴 예정이니, 그
            전까지는 각 코스 페이지의 커리큘럼과 실습 프로젝트를 먼저 둘러봐 주세요.
          </p>
          <small>COMING SOON</small>
        </ComingSoon>

        <Preview>
          <h3>이런 글들을 준비 중입니다</h3>
          <ul>
            <li>
              <strong>입문자가 가장 많이 막히는 5가지</strong>
              멘토들이 1:1 코드 리뷰에서 반복적으로 발견한 입문자 패턴.
            </li>
            <li>
              <strong>AI 코드 도우미 현명하게 쓰는 법</strong>
              어디까지 맡기고 어디서 사람이 검증해야 하는지의 경계선.
            </li>
            <li>
              <strong>포트폴리오용 프로젝트 1개 vs 흔한 프로젝트 5개</strong>
              취업 시장에서 실제로 가산점이 되는 결과물의 형태.
            </li>
            <li>
              <strong>전공 수업과 클럽 활동을 병행하는 법</strong>
              학기 중 시간 분배와 휴학기 / 방학기 활용 가이드.
            </li>
            <li>
              <strong>멘토가 본 좋은 질문, 아쉬운 질문</strong>
              질문하는 법을 배우면 학습 속도가 두 배가 됩니다.
            </li>
            <li>
              <strong>코드 리뷰를 받는 사람의 자세</strong>
              피드백을 방어하지 않고 흡수하는 실용적인 습관.
            </li>
          </ul>
        </Preview>
      </Section>
    </Page>
  );
};

export default BlogPage;
